import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/preventivi.json"

import FileSystemCommessa from "./fileSystemCommessa.js"
import DettaglioCommessa from "./recapCommessa.js"
import { DropzoneDialog } from 'material-ui-dropzone';

import * as ajax from "helpers/ajax";
import { ROLES } from "constant"


export default class PreventiviCommessa extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            groupID:this.props.groupID,
            commessa:this.props.data,
            commessaSelected: null,
            openFileSystem: false,
            openDetail: false,
            openUploader:false
        };
        
    }

    createFileSystem = (data) => {
        let formData = new FormData();
        formData.append("id", data.data.id)
        ajax.ajaxPost("/file_create_commessa.php", formData)
    }

    openFileSystem = (data) => {
        this.setState({ openFileSystem: true, commessaSelected: this.state.commessa });
    }

    uploadFiles = (files) => {
        let formData = new FormData();
        let path = "/commessa/" + this.state.commessa.id + "/preventivi";

        formData.append("path", path);
        files.map((file, index) => {
            formData.append("file[]", file);
        })

        ajax.ajaxPost("/file_upload.php", formData)
    }

    openUploader = () => {
        this.setState({ openUploader: true })
    }


    render() {
        if (this.state.commessaSelected && this.state.openFileSystem) {
            return <FileSystemCommessa data={this.state.commessaSelected} subfolder={"/preventivi"} backFunction={() => this.setState({ commessaSelected: null, openFileSystem: false })} />
        }

        return (
            
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Preventivi - "+this.state.commessa.nome}
                    subtitle={""}
                    icon={"request_page"}
                    backButton={this.props.backFunction}
                    menu={[{ label: "Carica Preventivi", function: this.openUploader }]}
                />

                <MDBox>
                    <MyDataTable
                        tableData={tableData}
                        filters={"&filters[commessa][id][$eq]=" + this.state.commessa.id + "&filters[$or][0][preventivi_group][id][$notNull]" + "&filters[$or][1][preventivi_group][id][$eq]=" + this.state.groupID}
                        edit={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        editCondition={(row) => this.state.commessa.stato != "finito"}
                        delete={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        add={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) && this.state.commessa.stato != "finito" ? true : false}
                        icon={"Personale"}
                        onDelete={(data) => console.log("eliminato", data)}
                        commessaID={this.state.commessa.id}
                        hiddenID={this.state.groupID}
                        customAction={[
                            {
                                icon: "folder",
                                color: "info",
                                function: this.openFileSystem
                            }
                        ]}
                    />
                </MDBox>

                {/*UPLOAD DOC*/}
                <DropzoneDialog
                    cancelButtonText={"Annulla"}
                    submitButtonText={"Invia"}
                    open={this.state.openUploader}
                    onClose={() => this.setState({ openUploader: false })}
                    onSave={(files) => {
                        this.uploadFiles(files)
                        this.setState({ openUploader: false })
                    }}
                    showPreviews={true}
                    showFileNamesInPreview={true}
                    filesLimit={10}
                />
                {/*FINE UPLOAD DOC*/}
            </DashboardLayout>
        )
    }
}


